export function resolveAssignedEmployerCnpj(
  requestedCnpj: string,
  assignedEmployers: readonly { cnpjFilial: string }[],
): string {
  return assignedEmployers.some((employer) => employer.cnpjFilial === requestedCnpj)
    ? requestedCnpj
    : '';
}
